import { configureStore } from "@reduxjs/toolkit";
import empresaReducer from "store/slice/empresaSlice";

export default configureStore({
  reducer: {
    empresa: empresaReducer,
  },
});
